import { useState } from 'react';
import Login from './Login';

export default function AuthPage() {
  const [, setView] = useState<'login' | 'register'>('login');

  return (
    <div>
      <Login setView={setView} />
    </div>
  );
}
